import {
  View,
  Text,
  Animated,
  Platform,
  StatusBar,
  TouchableOpacity,
  Dimensions,
  Keyboard,
} from "react-native";
import React from "react";
import { height, width } from "./imports";
import { orange, primary, success, white } from "./colors";
import A from "./assets/svg/A";
import S from "./assets/svg/S";
import Q from "./assets/svg/Q";
import ASQPEN from "./assets/svg/ASQ-PEN";
import { useRef } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import MyInputWithLabel from "./components/custom/MyInputWithLabel";

import { useState } from "react";

import { useDispatch } from "react-redux";

import Cookies from "universal-cookie";
import phoneLogin from "./api/post/phoneLogin";
import mailLogin from "./api/post/mailLogin";
import loginByOtp from "./api/post/loginByOtp";
import { storeStringData } from "./functions/db/db";
import { noModal } from "./redux/modal/modalAction";
import { addToken } from "./redux/main/mainAction";
import StepSlide from "./components/animation/StepSlide";
import translate from "./functions/translate";
import MyButton from "./components/custom/MyButton";
import CodeInput from "./components/custom/CodeInput";
import MyText from "./components/custom/MyText";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import { Toast } from "react-native-toast-message/lib/src/Toast";
const cookies = new Cookies();

function LoginModal({ visible }) {
  const dispatch = useDispatch();
  const modal = useSelector((store) => store.modal);
  const main = useSelector((store) => store.main);
  const [mode, setMode] = useState(1);
  const [timer, setTimer] = useState(60);
  const [timerMode, setTimerMode] = useState(1);
  const [code, setCode] = useState(null);
  const [changed, setChanged] = useState(false);
  const [input, setInput] = useState({
    phoneOrEmail: null,
  });
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    //dispatch(resetCode());

    let timeInterval = null;
    if (timerMode === 2) {
      timeInterval = setInterval(() => {
        setTimer((prev) => (prev <= 0 ? 0 : prev - 1));
      }, 1000);
    }

    return () => {
      setTimer(60);
      clearInterval(timeInterval);
    };
  }, [timerMode]);
  useEffect(() => {
    if (mode === 2) {
      setTimerMode(2);
    }
  }, [mode]);
  useEffect(() => {
    if (timer === 0) {
      setTimerMode(1);
    }
  }, [timer]);
  const sendCode = () => {
    setLoading(true);

    phoneLogin(input.phoneOrEmail)
      .then(({ data }) => {
        setLoading(false);

        if (data.status === 200) {
          setLoading(false);
          setMode((prev) => 2);
          setDetails({ otp: data.otp, temporaryToken: data.temporaryToken });
        } else {
          Toast.show({
            type: "error",
            text1: data.description.fa,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (code !== null) {
      setLoading(true);
      loginByOtp("phone", input.phoneOrEmail, details.temporaryToken, code)
        .then(({ data }) => {
          setLoading(false);
          if (data.status === 200) {
            if (Platform.OS === "web") {
              cookies.set("token", data.token);
            }
            dispatch(addToken(data.token));
            storeStringData("token", data.token);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [changed]);

  return (
    <View isVisible={modal.login} headerText={translate("login to account")}>
      <View
        style={{
          width: "100%",
          alignItems: "center",
          overflow: "hidden",
          marginTop: 100,
        }}
        dir={main.rtl ? "rtl" : "ltr"}
      >
        <StepSlide nextStep={mode === 2}>
          <View
            style={{
              width: Dimensions.get("window").width,
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <View style={{ width: "75%" }}>
              <View
                style={{ width: "100%", alignItems: "center", marginTop: 35 }}
              >
                <MyText style={{ marginTop: 100, color: white }}>
                  شماره تماس
                </MyText>
                <MyInputWithLabel
                  value={null}
                  keyboardType="number-pad"
                  name="phoneOrEmail"
                  setInput={setInput}
                  labelStyle={{ marginBottom: 5 }}
                />
              </View>
              <View
                style={{
                  marginVertical: 40,
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <MyButton
                  style={{ minHeight: 30, backgroundColor: success }}
                  loading={loading}
                  onPress={sendCode}
                  text={translate("get code")}
                />
              </View>
            </View>
          </View>
          <View
            style={{
              width: Dimensions.get("window").width,
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <View
              style={{
                width: "75%",
                alignItems: "center",
                paddingTop: 20,
                overflow: "hidden",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  width: "100%",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                <MyText style={{ marginHorizontal: 2 }}>
                  {translate("verify code sent to")}
                </MyText>
                <MyText>{`${input.phoneOrEmail}`}</MyText>
                <MyText>{translate("sent persian only")}</MyText>
              </View>
              <TouchableOpacity
                onPress={() => setMode(1)}
                style={{ marginVertical: 5 }}
              >
                <MyText style={{ color: orange }}>{translate("edit")}</MyText>
              </TouchableOpacity>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  width: "100%",
                }}
              >
                <View style={{ width: "90%", alignItems: "center" }}>
                  <CodeInput
                    direction={main.rtl ? "rtl" : "ltr"}
                    setCode={setCode}
                    codeDone={() => setChanged(!changed)}
                  />
                </View>
              </View>
              <MyButton
                style={{
                  minHeight: 30,
                  backgroundColor: success,
                  padding: 15,
                  marginTop: 20,
                }}
                loading={loading}
                onPress={() => setChanged(!changed)}
                text={translate("login")}
              />
            </View>
            <View
              style={{
                marginVertical: 20,
                flexDirection: "row",
                justifyContent: "center",
              }}
            ></View>
            {/* <View style={{ marginBottom: 4 }}>
              <MyText>error</MyText>
            </View> */}
            {timer !== 60 && (
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <MyText style={{ marginHorizontal: 2 }}>
                  {translate("resend in")}
                </MyText>
                <MyText style={{ marginHorizontal: 2 }}>{`${timer}`}</MyText>
                <MyText style={{ marginHorizontal: 2 }}>
                  {translate("seconds")}
                </MyText>
              </View>
            )}
            {timer === 60 && (
              <TouchableOpacity
                onPress={() => sendCode()}
                style={{ flexDirection: "row", alignItems: "center" }}
              >
                <MyText style={{ marginHorizontal: 2, color: primary }}>
                  {translate("resend code")}
                </MyText>
              </TouchableOpacity>
            )}
          </View>
        </StepSlide>
      </View>
    </View>
  );
}
export default function Splash({ setSplashDone }) {
  const main = useSelector((store) => store.main);
  const AAnimation = useRef(new Animated.Value(-height - 200)).current;
  const SAnimation = useRef(new Animated.Value(-height - 200)).current;
  const QAnimation = useRef(new Animated.Value(-height - 200)).current;
  const ASQPENAnimation = useRef(new Animated.Value(-height - 200)).current;

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      extraHeight={40}
      contentContainerStyle={{ alignItems: "center" }}
      style={{
        height:
          Platform.OS === "android" ? height + StatusBar.currentHeight : height,
        backgroundColor: primary,
        width: "100%",
      }}
    >
      <View
        style={{
          direction: "ltr",

          width: width,

          display: "flex",
          flexDirection:
            Platform.OS === "android" && main.rtl ? "row-reverse" : "row",
          justifyContent: "center",
          paddingTop: 100,
        }}
      >
        <Animated.View>
          <A />
        </Animated.View>
        <Animated.View>
          <S />
        </Animated.View>
        <Animated.View>
          <Q />
        </Animated.View>

        <Animated.View
          style={{
            marginLeft: Platform.OS === "android" && main.rtl ? 0 : -50,
            marginRight: Platform.OS === "android" && main.rtl ? -50 : 0,
          }}
        >
          <ASQPEN />
        </Animated.View>
      </View>
      <LoginModal />
    </KeyboardAwareScrollView>
  );
}
